export function verticalConsolidationDegree(timeFactor: number): number {
  if (!Number.isFinite(timeFactor) || timeFactor <= 0) return 0;
  const degree = timeFactor <= 0.283
    ? Math.sqrt((4 * timeFactor) / Math.PI)
    : 1 - (8 / Math.PI ** 2) * Math.exp(-(Math.PI ** 2 * timeFactor) / 4);
  return Math.max(0, Math.min(1, degree));
}

export function pvdEquivalentDiameter(widthMm: number, thicknessMm: number): number {
  return (2 * (widthMm + thicknessMm)) / 1000 / Math.PI;
}

export function pvdInfluenceDiameter(spacing: number, pattern: "triangular" | "square"): number {
  return (pattern === "triangular" ? 1.05 : 1.13) * spacing;
}

export function hansboSpacingFactor(nRatio: number): number {
  const n = Math.max(1.01, nRatio);
  return (n ** 2 / (n ** 2 - 1)) * Math.log(n) - (3 * n ** 2 - 1) / (4 * n ** 2);
}

export function radialConsolidationDegree(radialTimeFactor: number, resistanceFactor: number): number {
  if (radialTimeFactor <= 0 || resistanceFactor <= 0) return 0;
  return Math.max(0, Math.min(1, 1 - Math.exp((-8 * radialTimeFactor) / resistanceFactor)));
}

export function combineConsolidationDegrees(vertical: number, radial: number): number {
  return Math.max(0, Math.min(1, 1 - (1 - vertical) * (1 - radial)));
}
